export default "__VITE_ASSET__t9Sy4TWX__"